import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import * as VeeValidate from "vee-validate";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import eventBus from "./common/bus";
import "buefy/dist/buefy.css";
import "./sass/main.scss";
import "@/plugins/VeeValidate";
import Buefy from "buefy";
import { getModule } from "vuex-module-decorators";
import StoreVuexModule from "./store/StoreVuexModule";
import OidcPlugin from "./plugins/oidc";
import VueApexCharts from "vue-apexcharts";
import PageLayout from "@/views/PageLayout.vue";

// global components
Vue.component("fa-icon", FontAwesomeIcon);
Vue.component("ValidationProvider", VeeValidate.ValidationProvider);
Vue.component("page-layout", PageLayout);

// font-awesome
library.add(fas);
library.add(fab);

Vue.use(Buefy, {
  defaultIconComponent: "fa-icon",
  defaultIconPack: "fas",
  defaultContainerElement: "#app",
});

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

Vue.config.errorHandler = (err, vm, info) => {
  // display errors
  const errorMsg: string = "Component: " + vm.$options.name + "\n" + "Method: " + info + "\n" + "Error: " + err;
  eventBus.$emit("errorHandler", errorMsg);
};
Vue.config.productionTip = false;

(async () => {
  function setAppLoadingMessage(message: string, hideSpinner: boolean) {
    const textElem = document.getElementById("appLoadingMsg");
    if (textElem) {
      textElem.innerText = message;
    }

    const spinnerElem = document.getElementById("appLoadingSpinner");
    if (spinnerElem) {
      spinnerElem.style.display = hideSpinner ? "none" : "block";
    }
  }

  const vuexModule = getModule(StoreVuexModule, store);

  try {
    const res = await vuexModule.loadEnvironment();
    if (!res[0]) {
      setAppLoadingMessage(`Load Error: ${res[1] || "a unknown error occurred, please refresh to try again"}`, true);
      return;
    }

    Vue.use(OidcPlugin);

    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  } catch (err) {
    setAppLoadingMessage(`Load Error: ${"a unexpected error occurred, please refresh to try again"}`, true);
    // eslint-disable-next-line no-console
    console.error(err);
  }
})();
